<template>
    <div class="search_form">
        <div class="search_filed">
            <b-input-group>
                <b-input-group-text slot="prepend" >по ПІБ, посада</b-input-group-text>
                <b-form-input v-model="search"></b-form-input>
            </b-input-group>
        </div>
        <b-overlay :show="is_load">
            <user_list v-bind:users="userlist"></user_list>
        </b-overlay>
    </div>
</template>

<script>

import {createHelpers} from 'vuex-map-fields';
const {mapFields} = createHelpers({
    getterType: 'users_filter/getUfilterField',
    mutationType: 'users_filter/updateUfilterField',
});

import user_list from './users_list.vue'
    export default {
        name: "search",
        components : {
            user_list,
        },
        data() {
            return {
                is_load: false,
                form : {
                    search : '',
                    cur_type : 'search'
                },
            }
        },
        created() {
            this.load_users();
        },
        
        methods: {
            async load_users() {
                this.$store.dispatch('users_filter/SET_USERS_LIST', []);
                
                if (this.search.length > 2) {
                    this.is_load = true;
                    await api.post('/users', this.send_form).then(({data}) => {
                        this.$store.dispatch('users_filter/SET_USERS_LIST', data.data);
                        this.is_load = false;
                    }).catch(err => {
                        console.log(err);
                        this.is_load = false;
                    });
                }
            },
        },
        
        computed: {
            
            ...mapFields([
                'search',
                'users',
            ]),
            
            send_form () {
                this.form.search = this.search;
                return this.form;
            },
            
            userlist () {
                return  this.users;
            }
        },
        
        watch: {
            'search': function () {
                if(this.search.length > 2) {
                    this.load_users();
                }
                else {
                    this.$store.dispatch('users_filter/SET_USERS_LIST', []);
                }
            },
        }
    }
</script>

<style scoped>

</style>
